import React from 'react';
import data from '../../data/blogs.json';

function FamilyVisaBlog() {
  return (
    <section className="blog section-padding">
      <div className="container">
        <div className="row xlg-marg">
          <div className="col-lg-8">
            <div className="main-post">
              <div className="item pb-60">
                <div className="img mb-40">
                  <img src="/assets/images/blogs/family-visa-services-dubai-uae.png" alt="Family Visa Services in Dubai" className="w-100" />
                </div>
                
                <article>
                  <div className="title mb-30">
                    <h1>Family Visa Services in Dubai: A Complete Guide for Expats</h1>
                  </div>
                  
                  <div className="text">
                    <h4 className="fz-24 mb-20">Introduction</h4>
                    <p>
                      The Dubai is home to millions of expats who live and work in the country. For most of them, being able to bring their families is a top priority. Thanks to the government's <a className='main-color' href='/family-visa-services-dubai-uae'>family visa services in Dubai</a>, residents can sponsor their spouse, children, and even parents to live with them.
                    </p>
                    <p>
                      Whether you are working in Dubai, Abu Dhabi, or another emirate, understanding the process for applying for a Dubai family visa is essential to ensure a smooth and stress-free relocation for your loved ones.
                    </p>
                  </div>

                  <div className="title mt-30">
                    <h4>Who Can Sponsor a Family in Dubai?</h4>
                  </div>
                  <div className="text mt-20">
                    <p>
                      To apply for <span className='main-color'>family visa services in Dubai</span>, the sponsor must meet certain criteria:
                    </p>
                    
                    <div className="requirements-list mt-30 mb-30">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="requirement-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-wallet fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Salary requirement</h6>
                              <p className="fz-16 mb-0">Minimum salary of AED 4,000 or AED 3,000 + accommodation.</p>
                            </div>
                          </div>
                          
                          <div className="requirement-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-id-badge fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Valid Dubai residency visa</h6>
                              <p className="fz-16 mb-0">The sponsor must already have a residence visa.</p>
                            </div>
                          </div>
                          
                          <div className="requirement-item d-flex align-items-start">
                            <div className="icon mr-20">
                              <i className="ti-briefcase fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Profession flexibility</h6>
                              <p className="fz-16 mb-0">Earlier, only certain job categories could sponsor families, but now any profession can, provided the income requirement is met.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="title mt-30">
                    <h4>Who Can Be Sponsored Under Family Visa Dubai?</h4>
                  </div>
                  <div className="text mt-20">
                    <div className="sponsored-types mt-30">
                      <div className="type-item p-4 rounded mb-30">
                        <h5 className="mb-15">Spouse Visa Dubai</h5>
                        <ul className="rest mt-15 mb-0">
                          <li>A husband can sponsor his wife.</li>
                          <li>A wife may sponsor her husband under certain conditions (higher salary thresholds).</li>
                        </ul>
                      </div>
                      
                      <div className="type-item p-4 rounded mb-30">
                        <h5 className="mb-15">Children</h5>
                        <ul className="rest mt-15 mb-0">
                          <li>Sons up to 25 years old.</li>
                          <li>Daughters (unmarried, no age limit).</li>
                          <li>Newborns must be sponsored within 120 days of birth.</li>
                        </ul>
                      </div>
                      
                      <div className="type-item p-4 rounded">
                        <h5 className="mb-15">Parents</h5>
                        <p className="mb-0">
                          A resident can sponsor both parents with a higher income requirement (AED 20,000 salary or AED 19,000 + 2-bedroom accommodation).
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="title mt-50">
                    <h4>Documents Required for Dubai Family Visa Application</h4>
                  </div>
                  <div className="text mt-20">
                    <p>
                      To apply for <span className='main-color'>family visa services Dubai</span>, the following documents are generally required:
                    </p>
                    
                    <div className="documents-list bg-cream p-4 rounded mt-30 mb-30">
                      <ul className="rest">
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Valid passport copies of sponsor and family members.</span>
                        </li>
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Dubai residence visa and Emirates ID of sponsor.</span>
                        </li>
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Salary certificate or labor contract.</span>
                        </li>
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Tenancy contract (Ejari for Dubai).</span>
                        </li>
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Marriage certificate (attested).</span>
                        </li>
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Birth certificates of children (attested).</span>
                        </li>
                        <li className="mb-10 d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Recent photographs (passport size).</span>
                        </li>
                        <li className="d-flex align-items-start">
                          <i className="ti-file main-color mr-10 mt-5"></i>
                          <span>Medical fitness test reports for adults.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="title mt-50">
                    <h4>Process for Applying for Family Visa in Dubai</h4>
                  </div>
                  <div className="text mt-20">
                    <div className="steps-timeline position-relative mt-40">
                      <div className="step-item d-flex align-items-start mb-40">
                        <div className="step-number flex-shrink-0 mr-20">
                          <span className="circle d-flex align-items-center justify-content-center">1</span>
                        </div>
                        <div className="step-content">
                          <h5 className="mb-10">Entry Permit</h5>
                          <p className="mb-0">Apply for an entry permit (visa) for family members through GDRFA (General Directorate of Residency and Foreigners Affairs) or ICP (for other emirates).</p>
                        </div>
                      </div>
                      
                      <div className="step-item d-flex align-items-start mb-40">
                        <div className="step-number flex-shrink-0 mr-20">
                          <span className="circle d-flex align-items-center justify-content-center">2</span>
                        </div>
                        <div className="step-content">
                          <h5 className="mb-10">Medical Tests</h5>
                          <p className="mb-0">Adults must undergo medical screening in Dubai (HIV, TB, and other tests).</p>
                        </div>
                      </div>
                      
                      <div className="step-item d-flex align-items-start mb-40">
                        <div className="step-number flex-shrink-0 mr-20">
                          <span className="circle d-flex align-items-center justify-content-center">3</span>
                        </div>
                        <div className="step-content">
                          <h5 className="mb-10">Emirates ID Registration</h5>
                          <p className="mb-0">Submit biometrics and apply for Emirates ID cards for family members.</p>
                        </div>
                      </div>
                      
                      <div className="step-item d-flex align-items-start">
                        <div className="step-number flex-shrink-0 mr-20">
                          <span className="circle d-flex align-items-center justify-content-center">4</span>
                        </div>
                        <div className="step-content">
                          <h5 className="mb-10">Visa Stamping</h5>
                          <p className="mb-0">Once approved, the family visa Dubai is stamped in the passport, granting residency.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="title mt-50">
                    <h4>Validity of Family Visa Dubai</h4>
                  </div>
                  <div className="text mt-20">
                    <p>
                      Family visas can be issued for 1, 2, or 3 years, depending on the sponsor's visa validity.
                    </p>
                    <p className="mt-10">
                      Renewal must be done before expiration to avoid fines.
                    </p>
                  </div>

                  <div className="title mt-50">
                    <h4>Cost of Family Visa in Dubai </h4>
                  </div>
                  <div className="text mt-20">
                    <p>
                      The cost depends on visa duration and family members sponsored. On average:
                    </p>
                    
                    <div className="cost-list p-4 rounded mt-30 mb-30">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="cost-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-money fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Spouse/child visa</h6>
                              <p className="fz-16 mb-0">AED 3,000–5,000 (including medicals, Emirates ID, and stamping).</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="cost-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-money fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Parent visa</h6>
                              <p className="fz-16 mb-0">AED 5,000–6,000 (due to higher requirements and deposits).</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="title mt-50">
                    <h4>Benefits of Family Visa Services in Dubai</h4>
                  </div>
                  <div className="text mt-20">
                    <div className="benefits-list mt-30 mb-30">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="benefit-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-heart fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Family Unity</h6>
                              <p className="fz-16 mb-0">Live with family and enjoy a balanced lifestyle.</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="benefit-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-pulse fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Healthcare Access</h6>
                              <p className="fz-16 mb-0">Access to healthcare and insurance for dependents.</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="benefit-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-book fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Education Opportunities</h6>
                              <p className="fz-16 mb-0">Children's education in Dubai schools and universities.</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="benefit-item d-flex align-items-start mb-20">
                            <div className="icon mr-20">
                              <i className="ti-home fz-24 main-color"></i>
                            </div>
                            <div className="cont">
                              <h6 className="fz-18 mb-5">Long-term Residency</h6>
                              <p className="fz-16 mb-0">Long-term residency opportunities with Golden Visa Dubai eligibility for families.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="title mt-50">
                    <h4>Why Choose Bizdoc for Family Visa Services in Dubai?</h4>
                  </div>
                  <div className="text mt-20">
                    <p>
                      Applying for a Dubai family visa can be confusing due to documentation, attestations, and government approvals. At Bizdoc, we provide:
                    </p>
                    
                    <div className="services-list p-4 rounded mt-30 mb-30">
                      <div className="row">
                        <div className="col-md-6">
                          <ul className="rest">
                            <li className="mb-10 d-flex align-items-start">
                              <i className="ti-check-box main-color mr-10 mt-5"></i>
                              <span>Eligibility checks to confirm sponsorship requirements.</span>
                            </li>
                            <li className="mb-10 d-flex align-items-start">
                              <i className="ti-check-box main-color mr-10 mt-5"></i>
                              <span>Document attestation and preparation.</span>
                            </li>
                            <li className="mb-10 d-flex align-items-start">
                              <i className="ti-check-box main-color mr-10 mt-5"></i>
                              <span>Visa application support via GDRFA and ICP portals.</span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul className="rest">
                            <li className="mb-10 d-flex align-items-start">
                              <i className="ti-check-box main-color mr-10 mt-5"></i>
                              <span>Medical, Emirates ID, and visa stamping assistance.</span>
                            </li>
                            <li className="mb-10 d-flex align-items-start">
                              <i className="ti-check-box main-color mr-10 mt-5"></i>
                              <span>Renewals and dependents' management.</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    <p className="mt-30">
                      With our expertise, you can bring your loved ones to the Dubai without delays or complications.
                    </p>
                  </div>

                  <div className="title mt-50">
                    <h4>Conclusion</h4>
                  </div>
                  <div className="text mt-20">
                    <p>
                      The <strong className='main-color'>family visa services in Dubai</strong> make it possible for expats to enjoy life with their loved ones while building a future in the Emirates. Whether it's sponsoring your spouse, children, or parents, the process requires careful documentation and government approvals.
                    </p>
                    <p>
                      By partnering with Bizdoc, you can ensure that your <strong className='main-color'>family visa in Dubai</strong> is processed smoothly and efficiently.
                    </p>
                    <p className="mt-20">
                      📞 Contact Bizdoc today for trusted family visa consultants in Dubai, and let us help you reunite with your family.
                    </p>
                  </div>
                </article>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="sidebar sticky-sidebar">
              <div className="widget last-post-thum mb-40">
                <h6 className="title-widget mb-20">Latest Posts</h6>
                {data.slice(0, 3).map((post, index) => (
                  <div className="item d-flex align-items-center mb-20" key={index}>
                    <div className="flex-shrink-0">
                      <div className="img overflow-hidden rounded">
                        <a href={post.link}>
                          <img src={post.img} alt={post.title} className="img-fluid" />
                        </a>
                      </div>
                    </div>
                    <div className="flex-grow-1 ml-15">
                      <h6 className="fz-16">
                        <a href={post.link}>{post.title}</a>
                      </h6>
                      <span className="date fz-12">{post.date}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FamilyVisaBlog;